import React, {Component} from 'react';
import './MessageBox.css';

class MessageBox extends Component {
  render() {
    const messages = this.props.messages || [];

    if (messages.length === 0) {
      return <React.Fragment/>;
    }

    const { onClose, heading, dangerouslySetInnerHTML, warning } = this.props;
    const boxClassName = `c-message-box ${warning ? 'mb-warning' : ''} ${onClose ? 'c-message-box__closeable' : ''}`;
    return (
      <div className={boxClassName}>
        {onClose && <span className="c-close-button" onClick={onClose}>×</span>}
        {heading && <div className="c-centre-messages__heading">{heading}</div>}
        {dangerouslySetInnerHTML &&
         messages.map((value, i) => (
           <div className="message" key={'message-' + i} dangerouslySetInnerHTML={{ __html: value }}/>
         ))
        }
        {!dangerouslySetInnerHTML &&
         messages.map((value, i) => (
           <div className="message" key={'message-' + i}>
             {value}
           </div>
         ))
        }
      </div>
    );
  }
}

export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/MessageBox.js